import _objectWithoutProperties from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import gtm from '../../helpers/gtm';
import { isExternalLink } from '../../helpers/link';
import withMapping from '../../Context/withMapping';
import './style.scss';

var Button = function Button(_ref) {
  var href = _ref.href,
      dispatch = _ref.dispatch,
      className = _ref.className,
      children = _ref.children,
      primary = _ref.primary,
      inverted = _ref.inverted,
      language = _ref.language,
      enableLoader = _ref.enableLoader,
      loading = _ref.loading,
      htmlType = _ref.htmlType,
      props = _objectWithoutProperties(_ref, ["href", "dispatch", "className", "children", "primary", "inverted", "language", "enableLoader", "loading", "htmlType"]);

  var classes = classNames('Button', className, {
    'Button--primary': primary,
    'Button--inverted': inverted,
    'is-loading': loading
  });

  var onClick = function onClick(event) {
    if (loading) return; // Using element.innerText gives us purely the text of the element which is
    // perfect for the tracking event. We don't want a string containing HTML.

    var text = event.target ? event.target.innerText : 'Unknown';
    gtm.trackUserEvent('button', 'click', text, href);

    if (props.onClick) {
      props.onClick(event);
    }
  };

  if (!href) {
    return /*#__PURE__*/React.createElement("button", _extends({
      type: htmlType,
      className: classes,
      href: href
    }, props, {
      onClick: onClick
    }), children);
  }

  return isExternalLink(href) ? /*#__PURE__*/React.createElement("a", _extends({
    className: classes,
    href: href,
    target: "_blank",
    rel: "noreferrer noopener"
  }, props, {
    onClick: onClick
  }), children) : /*#__PURE__*/React.createElement(Link, _extends({
    to: href,
    className: classes
  }, props, {
    onClick: onClick
  }), children);
};

Button.defaultProps = {
  primary: true,
  inverted: false,
  enableLoader: false,
  htmlType: 'button'
};
Button.propTypes = {
  primary: PropTypes.bool,
  inverted: PropTypes.bool,
  enableLoader: PropTypes.bool,
  htmlType: PropTypes.oneOf(['button', 'submit', 'reset'])
};
export default withMapping(Button);